require('../../vendor/rmts/scoop-os/resources/js/bootstrap.js');

$('.selector').tooltip({
    tooltipClass: "tooltip",
});
